export default {
  namespaced: true,
  pbx_ip_block: {
    title: "Bloqueo de IPs",
    ip: "Dirección IP",
    ban_ip: "Bloquear una IP",
    ip_placeholder: "Ej. x.x.x.x",
    ban: "Bloquear",
    unban: "Desbloquear",
    unban_selected: "Desbloquear seleccionadas",
    empty: "No hay direcciones IP bloqueadas",
    loading: "Cargando direcciones IP...",
    messages: {
      ban_success: "La IP {ip} fue bloqueada correctamente",
      unban_success: "La IP {ip} fue desbloqueada correctamente",
      bulk_success: "Se desbloquearon {count} direcciones IP",
      bulk_error: "No fue posible desbloquear {count} direcciones IP",
    },
  },
};
